// extracted by mini-css-extract-plugin
export default {"card":"f3-z"};